import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';

//middleware
import thunkMiddleware from 'redux-thunk';
import authMiddleWare from './Middleware/auth.middleware';

//front end styling css
//import 'semantic-ui-css/semantic.min.css';
import './CSS/dist/semantic.min.css';

//redux and middleware needed to create store
import { createStore, applyMiddleware } from 'redux';
import rootReducer from './Reducers/RootReducer';

//Different possible options for redux dev tools in various environments
//import { composeWithDevTools } from 'redux-devtools-extension';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
//import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import { beginAuthSession } from './Actions/AuthActions';

// Check for JWT in query string, if found this starts the session
beginAuthSession(window.location.hash || window.location.search);

const composeEnhancers = composeWithDevTools(
  {
    // options like actionSanitizer, stateSanitizer
  }
);
const middleware = [ thunkMiddleware, authMiddleWare ];

let store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middleware)));

ReactDOM.render(<App store={store} />, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js